import IconButton from '@mui/material/IconButton';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import { useRootStore } from '../hooks/useRootStore';
import { observer } from 'mobx-react-lite';
import AddActivityDialog, { NewActivityData } from './AddActivityDialog';
import './ActiveIssue.css';
import { useState } from 'react';

const TrackingToggler = observer(({ id, size, playColor, stopColor }: { id: number | null | undefined, size: number, playColor: string, stopColor: string }) => { // TODO сделать нормальный color

    const { api, activityStarted, setActivityStartTime, activityStartTime, globalError } = useRootStore();

    const [newActivityOpen, setNewActivityOpen] = useState(false);

    const [tmpText, setTmpText] = useState('');

    const onActivitySubmit = async (ActivityData: NewActivityData) => {
        ActivityData.issueId = id as number;
        await api.postIssueAcivity(ActivityData)
            .then(() => {
                //localStorage.removeItem('activityStartedAt');
                setActivityStartTime(null);
                setNewActivityOpen(false);
                setTmpText('');
                localStorage.setItem('lastActivitiSkillID', ActivityData.skillId.toString());
            })
    }

    const handleActivityChanged = () => {
        if (id) {
            if (activityStarted) {
                setNewActivityOpen(true);
            } else {
                setActivityStartTime(new Date());
            }
        }
    }

    return (
        <>
            {newActivityOpen && activityStarted ?
                <AddActivityDialog
                    startDate={activityStartTime!}
                    endDate={new Date}
                    defaultText={tmpText}
                    onSubmit={onActivitySubmit}
                    onResume={(text: string) => { globalError.reset(); setTmpText(text); setNewActivityOpen(false); }}
                    onTimerCancel={() => { globalError.reset(); setTmpText(''); setNewActivityOpen(false); }}
                /> : ''}
            <IconButton
                onClick={handleActivityChanged}
                title={activityStarted ? "Остановить активность и записать результат" : "Начать активность"}
                sx={{ p: 0, pb: "1px" }}
            >
                {activityStarted ? <StopCircleIcon style={{ opacity: 1, color: stopColor, width: `${size}px`, height: `${size}px` }} /> : <PlayCircleFilledIcon style={{ outline: "none", border: "none", color: playColor, width: `${size}px`, height: `${size}px` }} />}
            </IconButton>
        </>
    );
})

export default TrackingToggler;